import DashLayout from "@/layouts/DashLayout";
import PageTitle from "@/components/PageTitle";
import RoleProtectedPage from "@/layouts/RoleProtectedPage";
import { Roles } from "@/redux/services/user/user.type";
import { useAppSelector } from "@/redux/features/hooks";
import ExpensesList from "@/components/expenses/ExpensesList";

const ExpensesPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);

  return (
    <DashLayout>
      <RoleProtectedPage
        allowedRoles={[Roles.manager, Roles.owner]}
        allowedPermissions={["expenses.view"]}
      >
        <div className="space-y-6">
          <PageTitle
            title="Dépenses"
            description="Enregistrez et suivez les dépenses de fonctionnement du restaurant"
          />
          {/* The revenue/expenses overview now lives on the Rapports page, next
              to the sales report and driven by the same period selector. */}
          {restaurant && <ExpensesList restaurantId={restaurant.id} />}
        </div>
      </RoleProtectedPage>
    </DashLayout>
  );
};

export default ExpensesPage;
